import React, { useEffect, useState } from 'react';
import './edit-history.css';
import { apiGet } from '../../apiHelpers';
import { BuildingEditLatest } from './building-edit-latest';
const EditHistoryLatest = (props) => {
    const [history, setHistory] = useState(undefined);
    useEffect(() => {
        const fetchData = async () => {
            const { history } = await apiGet(`/api/buildings/${props.building.building_id}/history.json`);
            setHistory(history);
        };
        if (props.building != undefined) { // only call fn if there is a building provided
            fetchData(); // define and call, because effect cannot return anything and an async fn always returns a Promise
        }
    }, [props.building]); // only re-run effect on building prop change
    return (React.createElement(React.Fragment, null,
        React.createElement("ul", { className: "edit-history-first", id: "first-only" }, history && history.map(entry => (React.createElement("li", { key: `${entry.revision_id}`, className: "edit-history-list-element" },
            React.createElement(BuildingEditLatest, { historyEntry: entry })))))));
};
export { EditHistoryLatest };
